module.exports = __webpack_public_path__ + "static/img_1233-ef123aede15e908fb4f3593edde41267.webp";